import React from "react";
import Script from "react-load-script";
import { compose, lifecycle } from "recompose";

const url =
  "//cdn.finra.org/brokercheck2210-widget/assets/js/min/addbcwidget.min.js?firmname=CUSO%20Financial%20Services%2C%20L.P.&crds=42132";

const BrokerCheck = () => (
  <div id="bc-root">
    <Script url={url} attributes={{ id: "bcwidgetId" }} />
  </div>
);

const enhance = compose(
  lifecycle({
    componentWillUnmount() {
      const el = document.getElementById("bcwidgetId");
      if (el) {
        el.parentElement.removeChild(el);
        delete Script.loadedScripts[url];
        delete Script.scriptObservers[url];
      }
    },
  })
);

export default enhance(BrokerCheck);



// WEBPACK FOOTER //
// ./src/components/Content/Module/BrokerCheck.js